import { supabase } from "../supabase/supabaseClient";

// Player profile functions
export async function getPlayerProfile(userId) {
    return await supabase
        .from("player_profiles")
        .select("*")
        .eq("user_id", userId)
        .maybeSingle();
}

export async function updatePlayerProfile(userId, payload) {
    return await supabase
        .from("player_profiles")
        .update(payload)
        .eq("user_id", userId);
}

// Org/Scout profile functions
export async function getOrgProfile(userId) {
    return await supabase
        .from("org_profiles")
        .select("*")
        .eq("org_id", userId)
        .maybeSingle();
}

export async function updateOrgProfile(userId, payload) {
    return await supabase
        .from("org_profiles")
        .update(payload)
        .eq("org_id", userId);
}
//User profile functions
export async function getUserProfile(userId) {
    return await supabase
        .from("user_profiles")
        .select("*")
        .eq("user_id", userId)
        .maybeSingle();
}
export async function updateUserProfile(userId, payload) {
    return await supabase
        .from("user_profiles")
        .update(payload)
        .eq("user_id", userId);
}

const ALLOWED_AVATAR_TYPES = ["image/jpeg", "image/png", "image/webp"];
const MAX_AVATAR_SIZE = 5 * 1024 * 1024; // 5 MB
const EXT_MAP = { "image/jpeg": "jpg", "image/png": "png", "image/webp": "webp" };

export async function uploadAvatar(userId, file) {
    if (!ALLOWED_AVATAR_TYPES.includes(file.type)) {
        return { data: null, error: new Error("Only JPEG, PNG, and WebP images are allowed.") };
    }
    if (file.size > MAX_AVATAR_SIZE) {
        return { data: null, error: new Error("Image must be 5 MB or smaller.") };
    }

    const ext = EXT_MAP[file.type];
    const filePath = `${userId}/avatar.${ext}`;

    const { error: uploadError } = await supabase.storage
        .from("avatars")
        .upload(filePath, file, { upsert: true, contentType: file.type });

    if (uploadError) return { data: null, error: uploadError };

    const { data: urlData } = supabase.storage.from("avatars").getPublicUrl(filePath);
    // Cache-bust so React re-renders the new image immediately
    const avatarUrl = `${urlData.publicUrl}?t=${Date.now()}`;

    // Keep both tables in sync so player cards, profiles, and explore all see the new photo.
    // Do not fail if one table has no matching row, but surface real update errors.
    const [{ error: userProfileError }, { error: playerProfileError }] = await Promise.all([
        supabase.from("user_profiles").update({ avatar_url: avatarUrl }).eq("user_id", userId),
        supabase.from("player_profiles").update({ avatar_url: avatarUrl }).eq("user_id", userId),
    ]);

    if (userProfileError && playerProfileError) {
        return {
            data: null,
            error: new Error(`Avatar uploaded but profile update failed: ${userProfileError.message || "user_profiles"} | ${playerProfileError.message || "player_profiles"}`),
        };
    }

    return { data: { avatar_url: avatarUrl }, error: null };
}

